import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRecoveryCodeState } from "../../../types/recoveryCodes/recoveryCodeInterfaces";

export const initialState: IRecoveryCodeState = {
    codes: [],
    showCodes: false,
    generated: false,
    loading: false,
    error: null,
};

export const recoveryCodeSlice = createSlice({
    name: "recoveryCodes",
    initialState,
    reducers: {
        setCodes: (state, action: PayloadAction<string[]>) => {
            console.log("Recovery Codes Generated", action.payload);
            state.codes = action.payload;
            state.generated = true;
            state.showCodes = true;
            state.error = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
        },
        resetCodes: (state) => {
            state.codes = [];
            state.generated = false;
            state.error = null;
        },
        resetShowCodes: (state) => {
            state.showCodes = false;
            state.codes = [];
            state.error = null;
            state.loading = false;
        }
    },
});

// Exportar acciones
export const { setCodes, setLoading, setError, resetCodes, resetShowCodes } = recoveryCodeSlice.actions;

// Exportar reducer
export default recoveryCodeSlice.reducer;
